import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'number-1-small', 'IconNumber1Small', [["path",{"d":"M10 10l2 -2v8","key":"svg-0"}]]);